/* hemp-pillar.js (sticky + jump links + auto-ID assignment) */
(function () {
  function init() {
    var bar = document.querySelector('[data-hemp-jump]');
    if (!bar || bar.dataset.hempInit === "1") return;
    bar.dataset.hempInit = "1";

    // ---------- Spacer (prevents content jump when bar becomes fixed) ----------
    var spacer =
      document.querySelector(".hemp-jump-spacer") || document.createElement("div");
    spacer.className = "hemp-jump-spacer";
    if (!spacer.parentNode) bar.parentNode.insertBefore(spacer, bar);

    // ---------- Helpers ----------
    function getHeader() {
      return (
        document.querySelector("#shopify-section-header") ||
        document.querySelector(".shopify-section--header") ||
        document.querySelector("header")
      );
    }

 function headerOffset() {
  var h = getHeader();
  var NUDGE = -90 // 👈 move bar UP (try -8, -12, -16)
  return h ? Math.round(h.getBoundingClientRect().height) + NUDGE : 0;
}

    function normalize(s) {
      return (s || "").trim().toLowerCase().replace(/\s+/g, " ");
    }

    function getScope() {
      return (
        document.querySelector(".main-page-content .rte") ||
        document.querySelector(".main-page-content") ||
        document.querySelector("#MainContent") ||
        document
      );
    }

    function findHeadingByText(findText) {
      if (!findText) return null;
      var want = normalize(findText);
      var scope = getScope();
      var headings = scope.querySelectorAll("h1, h2, h3");

      for (var i = 0; i < headings.length; i++) {
        var h = headings[i];
        var txt = normalize(h.textContent);
        if (txt.includes(want)) return h;
      }
      return null;
    }

    function setCssVars() {
      var top = headerOffset();
      document.documentElement.style.setProperty("--hemp-jump-top", top + "px");
      document.documentElement.style.setProperty("--hemp-jump-height", bar.offsetHeight + "px");
      spacer.style.height = bar.classList.contains("is-fixed") ? bar.offsetHeight + "px" : "0px";
    }

    function docTop(el) {
      var y = 0;
      while (el) {
        y += el.offsetTop || 0;
        el = el.offsetParent;
      }
      return y;
    }

    var barStart = docTop(bar);

    // ---------- Sticky / Fixed behavior ----------
    function updateSticky() {
      setCssVars();

      // recalc start while not fixed (layout can shift after images load)
      if (!bar.classList.contains("is-fixed")) {
        barStart = docTop(bar);
      }

      var shouldFix = window.scrollY >= (barStart - headerOffset());

      if (shouldFix && !bar.classList.contains("is-fixed")) {
        bar.classList.add("is-fixed");
        spacer.classList.add("is-on");
        setCssVars();
      } else if (!shouldFix && bar.classList.contains("is-fixed")) {
        bar.classList.remove("is-fixed");
        spacer.classList.remove("is-on");
        setCssVars();
      }
    }

    // ---------- Smooth scroll with offset ----------
    function scrollToEl(el, smooth) {
      setCssVars();
      var y =
        el.getBoundingClientRect().top +
        window.scrollY -
        headerOffset() -
        bar.offsetHeight -
        12;

      window.scrollTo({ top: y, behavior: smooth ? "smooth" : "auto" });
    }

    bar.addEventListener("click", function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;

      var hash = link.getAttribute("href");
      if (!hash || hash === "#") return;

      var id = hash.slice(1);
      var target = document.getElementById(id);

      // If the id doesn't exist, find heading by text and assign id
      if (!target) {
        var findText = link.getAttribute("data-find");
        var heading = findHeadingByText(findText);
        if (heading) {
          heading.id = id;
          target = heading;
        }
      }

      if (!target) return;

      e.preventDefault();
      history.pushState(null, "", hash);
      scrollToEl(target, true);
    });

    // ---------- Initial / Hash load ----------
    function onLoadHash() {
      if (!window.location.hash) return;

      var id = window.location.hash.slice(1);
      var target = document.getElementById(id);

      if (!target) {
        var link = bar.querySelector('.hemp-jump__link[href="' + window.location.hash + '"]');
        if (link) {
          var heading = findHeadingByText(link.getAttribute("data-find"));
          if (heading) {
            heading.id = id;
            target = heading;
          }
        }
      }

      if (target) scrollToEl(target, false);
    }

    // ---------- Bind ----------
    updateSticky();
    setTimeout(function () {
      barStart = docTop(bar);
      updateSticky();
    }, 400);

    window.addEventListener("scroll", updateSticky, { passive: true });
    window.addEventListener("resize", function () {
      barStart = docTop(bar);
      updateSticky();
    });

    window.addEventListener("load", function () {
      updateSticky();
      onLoadHash();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:select", init);
})();

